
<div
    ref="container"
    class="ScrollableContainer"
    :class="{ 'is-scrollable': showGradient }"
    :style="{ '--max-height': maxHeight }"
    @scroll="handleScroll"
>
    <div class="ScrollableContainer-content">
        <div v-if="items && items.length > 0">
            <div
                v-for="(item, index) in items"
                :key="getItemKey(item, index)"
                class="item-wrapper"
                :style="{ 'contain-intrinsic-size': `${itemHeight}px` }"
            >
                <slot :item="item" :index="index" />
            </div>
        </div>
        <div v-if="!items || items.length === 0" class="empty-list">
            <slot />
        </div>
    </div>
    <div
        v-if="showGradient"
        class="ScrollableContainer-gradient"
        :style="{ opacity: gradientOpacity }"
    ></div>
</div>
